import Carousel from "@components/Carousel";
import LargeTile from "@components/LargeTile";
import { ForYouData } from "@hooks/trpc/useForYou";
import { RecommendedArtistsData } from "@hooks/trpc/useRecommendedArtists";
import { RecommendedPlaylistsData } from "@hooks/trpc/useRecommendedPlaylists";
import React from "react";

type HomeCarouselProps = {
  items: (ForYouData | RecommendedArtistsData | RecommendedPlaylistsData)[];
  onEndReached?: () => void;
  onEndReachedThreshold?: number;
  screen: "home" | "library" | "explore" | null;
  title: string;
};

const HomeCarousel = ({
  items,
  onEndReached,
  onEndReachedThreshold = 0.35,
  screen,
  title,
}: HomeCarouselProps) => {
  return (
    <Carousel
      data={items}
      onEndReached={onEndReached}
      onEndReachedThreshold={onEndReachedThreshold}
      renderItem={({ item: collection }) => (
        <LargeTile item={collection} screen={screen} />
      )}
      title={title}
    />
  );
};

export default HomeCarousel;
